// decrypte.js
import CryptoJS from 'crypto-js';

const secretKey = 'fikikadena202420';

const AesEncrypt = (data) => {
  const dataString = String(data);
  return CryptoJS.AES.encrypt(dataString, secretKey).toString();
}

const encrypt = (data) => {
  try {
    const dataString = typeof data === 'string' ? data : JSON.stringify(data);
    const ciphertext = CryptoJS.AES.encrypt(dataString, secretKey).toString();
    return ciphertext;
  } catch (error) {
    console.error('Error encrypting data:', error);
    return null;
  }
};

const decrypt = (ciphertext) => {
  if (!ciphertext) {
    return null; 
  }
  const bytes = CryptoJS.AES.decrypt(ciphertext, secretKey);
  if (bytes.sigBytes === 0) {
    return null;
  }
  const originalText = bytes.toString(CryptoJS.enc.Utf8);
  return originalText;
};

export { encrypt, decrypt, AesEncrypt};
